import React from "react";
import { PageHero, Section, OBJECTIVES, FEATURES, TRADES, AFFILIATION } from "./_shared";
import { CheckCircle2, Briefcase, ShieldCheck, Award, Calendar, Building2 } from "lucide-react";

export default function About() {
  const trade = TRADES[0];
  return (
    <div data-testid="mitmcvc-about">
      <PageHero
        eyebrow="आमच्याविषयी"
        title="एम.आय.टी. एच.एस.सी. व्होकेशनल (एम.सी.व्ही.सी.) कनिष्ठ महाविद्यालय"
        sub="ग्रामोद्योगिक शिक्षण मंडळ, छत्रपती संभाजीनगर संचलित — सिडको एन-४ येथे वर्ष १९८८–८९ पासून कार्यरत, दर्जेदार तांत्रिक शिक्षण देणारी सुसज्ज संस्था."
      />

      {/* प्रस्तावना */}
      <Section>
        <div className="grid md:grid-cols-[1fr_auto] gap-10 items-start">
          <div>
            <div className="text-[10px] tracking-[0.35em] uppercase text-[#B45309] font-bold">प्रस्तावना</div>
            <h2 className="font-serif text-2xl md:text-3xl text-[#14532D] mt-2 leading-snug">एका दृष्टीकोनातून उभी राहिलेली संस्था</h2>
            <p className="mt-5 text-slate-800 leading-relaxed">
              ग्रामोद्योगिक शिक्षण मंडळ, छत्रपती संभाजीनगर यांनी ग्रामीण भागातील होतकरू विद्यार्थ्यांची शिक्षणाबाबतची तळमळ व गरज ओळखून वर्ष १९८८–८९ पासून एम.आय.टी. एच.एस.सी. व्होकेशनल (एम.सी.व्ही.सी.) कनिष्ठ महाविद्यालय ही संस्था छत्रपती संभाजीनगर जिल्ह्यात सिडको, एन-४ या ठिकाणी सुरू केली आहे.
            </p>
            <p className="mt-4 text-slate-800 leading-relaxed">
              छत्रपती संभाजीनगर जिल्ह्यातील सुरू असलेल्या सर्व खाजगी संस्थांपैकी दर्जेदार तांत्रिक शिक्षण देणारी व सर्व सोयींनी सुसज्ज अशी ही संस्था आहे. सदर संस्थेतून आजपर्यंत <span className="font-bold text-[#14532D]">३०००</span> पेक्षा जास्त प्रशिक्षणार्थ्यांनी आपला अभ्यासक्रम पूर्ण करून मोठ्या-मोठ्या कंपन्यांमध्ये तसेच शासकीय आस्थापनांत रुजू होऊन काम करीत आहेत. तसेच बरेचसे विद्यार्थी स्वतःचा व्यवसाय करून स्वावलंबी झाले आहेत.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <FactCard icon={<Calendar />} label="स्थापना" value="१९८८–८९" />
              <FactCard icon={<Award />} label="नोंदणी क्रमांक" value="56.01.066" />
              <FactCard icon={<ShieldCheck />} label="U-DISE" value="90100000095" />
              <FactCard icon={<Building2 />} label="स्थळ" value="सिडको एन-४, छ. संभाजीनगर" />
            </div>
          </div>

          <aside className="bg-white border-l-4 border-[#F59E0B] p-6 md:min-w-[300px] shadow-sm">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#B45309] font-bold">संलग्नता</div>
            <div className="mt-2 text-sm text-slate-800 leading-relaxed">{AFFILIATION}</div>
            <div className="mt-4 text-[10px] tracking-[0.25em] uppercase text-slate-500">व्यवस्थापन</div>
            <div className="mt-1 text-sm font-semibold text-[#14532D]">ग्रामोद्योगिक शिक्षण मंडळ,<br />छत्रपती संभाजीनगर</div>
          </aside>
        </div>
      </Section>

      {/* उद्देश */}
      <div className="bg-[#14532D] text-white">
        <Section className="!py-16">
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#F59E0B] font-bold">संस्थेचा मुख्य उद्देश</div>
          <h2 className="font-serif text-3xl mt-2">आम्ही का अस्तित्वात आहोत</h2>
          <div className="mt-8 grid md:grid-cols-2 gap-5">
            {OBJECTIVES.map((o, i) => (
              <div key={i} className="bg-white/5 border border-white/10 p-6">
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#F59E0B] font-bold">उद्देश {String(i + 1).padStart(2, "0")}</div>
                <div className="mt-2 text-white/90 leading-relaxed">{o}</div>
              </div>
            ))}
          </div>
        </Section>
      </div>

      {/* अभ्यासक्रम - Automobile Technology */}
      <Section>
        <div className="text-[10px] tracking-[0.35em] uppercase text-[#B45309] font-bold">सुरू असलेला अभ्यासक्रम</div>
        <h2 className="font-serif text-3xl mt-2 text-[#14532D]">{trade.nameMr} <span className="text-slate-500 text-lg italic">({trade.nameEn})</span></h2>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-3xl">
          <MetaCard label="प्रशिक्षण कालावधी" value={trade.duration} />
          <MetaCard label="शैक्षणिक अर्हता" value={trade.qualification} />
          <MetaCard label="प्रवेश क्षमता" value={trade.intake} />
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-6">
          <div className="bg-white border border-amber-100 p-6">
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#14532D]">व्यवसायाची माहिती व शिकविली जाणारी कौशल्ये</div>
            <ul className="mt-4 space-y-2.5">
              {trade.highlights.map((h, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-slate-700">
                  <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-[#F59E0B]" />
                  <span>{h}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-[#14532D] text-white p-6">
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#F59E0B]">रोजगार व नोकरीच्या संधी</div>
            <ul className="mt-4 space-y-2.5">
              {trade.prospects.map((p, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-white/90">
                  <Briefcase size={14} className="mt-0.5 shrink-0 text-[#F59E0B]" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Section>

      {/* वैशिष्ट्ये */}
      <div className="bg-white border-t border-amber-100">
        <Section>
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#B45309] font-bold">संस्थेची वैशिष्ट्ये</div>
          <h2 className="font-serif text-3xl mt-2 text-[#14532D]">आमच्या संस्थेत काय आहे</h2>
          <div className="mt-8 grid md:grid-cols-2 gap-4">
            {FEATURES.map((f, i) => (
              <div key={i} className="flex items-start gap-3 bg-[#FEF8E8] border border-amber-100 p-5">
                <div className="w-8 h-8 shrink-0 bg-[#F59E0B]/15 text-[#B45309] font-bold flex items-center justify-center text-sm font-mono">{String(i + 1).padStart(2, "0")}</div>
                <div className="text-sm text-slate-800 leading-relaxed pt-1">{f}</div>
              </div>
            ))}
          </div>
        </Section>
      </div>
    </div>
  );
}

function FactCard({ icon, label, value }) {
  return (
    <div className="bg-white border border-amber-100 p-4 flex items-center gap-3">
      <div className="w-10 h-10 flex items-center justify-center bg-[#F59E0B]/15 text-[#B45309]">{icon}</div>
      <div className="min-w-0">
        <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500">{label}</div>
        <div className="text-sm font-bold text-[#14532D] truncate">{value}</div>
      </div>
    </div>
  );
}

function MetaCard({ label, value }) {
  return (
    <div className="border border-amber-100 bg-white px-4 py-3">
      <div className="text-[10px] tracking-[0.25em] uppercase text-[#B45309] font-bold">{label}</div>
      <div className="text-sm font-bold text-[#14532D] mt-0.5">{value}</div>
    </div>
  );
}
